export const FEATURE_NAME = 'patients';

export const LIST = 'list';
export const FILTERS = 'filters';

export const FIRST_NAME = 'firstname';
export const LAST_NAME = 'lastname';
export const GENDER = 'gender';
export const BIRTH = 'birthday';
export const ADDRESS = 'address';
export const CARE_OF = 'careOf';
export const ZIP_CODE = 'zipCode';
export const CANTON = 'canton';
export const COUNTRY = 'country';
export const CITY = 'city';
export const TOWN = 'town';
export const STREET = 'street';
export const HOUSE = 'houseNo';
export const PHONE = 'phone';
export const EMAIL = 'email';
export const NATIONAL = 'nationality';
export const NUMBER = 'number';
// export const VEKA = 'veka';
export const MODEL = 'model';
export const SUPPLEMENT = 'supplement';
export const SSN = 'ssn';
export const CORRESPONDENCE = 'correspondence';
export const WARD = 'ward';
export const TITLE = 'title';
export const NURSING_HOME = 'nursingHome';
export const IS_EMERGENCY = 'isEmergency';
export const INVOICE_ONLY = 'invoiceOnly';
export const REPORT_ONLY = 'reportOnly';
export const INSTITUTION = 'institution';
export const INSURANCE = 'insurance';
export const MEDIA = 'media';
export const REMUNERATION = 'remuneration';
export const TIERS_GARANT = 'tiers_garant';
export const TIERS_PAYANT = 'tiers_payant';
export const FROM = 'from';
export const TO = 'to';

export const OTHER_CONTACTS = 'otherContacts';

export const AGENT = 'representative';
export const FAMILY_DOCTOR = 'gp';
export const EYE_DOCTOR = 'eyeDoctor';
export const CONTACT_TYPE = 'contact';
export const REFERRAL_PARTNER = 'referralPartner';

export const OPTICIAN = 'optician';
export const GUARANTY = 'costGuaranty';
export const PATIENT = 'patient';

export const PUBLIC_ID = 'publicId';

export const PATIENT_REPORTS = 'patient_reports';
export const REPORTS = 'reports';
export const NO_REPORT = 'noReport';
export const RECURRING_EXAMINATION = 'recurringExamination';

export const LAW_TYPE = 'lawType';
export const LAW_TYPES = 'lawTypes';
export const LAW_TYPE_KINDS = { KVG: 1, UVG: 2, IVG: 3, MVG: 4 };
export const LAW_TYPE_LABELS = {
  [LAW_TYPE_KINDS.KVG]: 'KVG',
  [LAW_TYPE_KINDS.UVG]: 'UVG',
  [LAW_TYPE_KINDS.IVG]: 'IVG',
  [LAW_TYPE_KINDS.MVG]: 'MVG',
};

export const CONTACT_NAMES = [
  {
    id: PATIENT,
    title: 'Patient',
  },
  {
    id: NURSING_HOME,
    title: 'Pflegezentrum',
  },
  {
    id: OPTICIAN,
    title: 'Optiker',
  },
  {
    id: AGENT,
    title: 'Gesetzlicher Vertreter',
  },
  {
    id: CONTACT_TYPE,
    title: 'Kontaktperson',
  },
  {
    id: FAMILY_DOCTOR,
    title: 'Hausarzt/-ärztin',
  },
  {
    id: EYE_DOCTOR,
    title: 'Augenarzt/-ärztin',
  },
  {
    id: REFERRAL_PARTNER,
    title: 'Zuweisung',
  },
];
